<template>
	<div class="store-basic-info">
		<Search :freightType='freightType' :page="params.page" :size="params.size" :showFlag="showFlag" :shopid="params.shopIds" @getTableData="getTableDataHandle" @getParamsData="getParamsData" ref="search"></Search>
		<div class="features-btn-box">
			<div v-if="AuthorityList['02_0001_0006_00']" class="batch-register-btn" @click="exportExcel">
				<i class="excel-icon export-excel-icon"/>
				<span>导出</span>
			</div>
		</div>
		<div class="table-div">
			<div style="height:100%">
			<div class="table-box">
				<el-table
					:stripe='false'
					class="grid-content goods-table"
					:data="tableData"
					size='mini'
					@row-dblclick='rowClick'
					:height="tableHeight"
					border
					ref="table"
					:row-class-name="tableRowClassName"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						prop="url"
						label="商品信息"
						align="center"
						min-width="300"
						:render-header="renderHeader">
						<template slot-scope="scope">
							<div class="goods-table-info">
								<div class="goods-table-fold"><span class="showFlag" @click="showFold(scope.$index)">{{scope.row.showFlag ? '-' : '+'}}</span></div>
								<img v-if="scope.row.url === ''" src="~/images/img/no-goods-img.png" style="width: 80px; height:80px">
								<w-image v-else :src="scope.row.url" style="width: 80px;height:80px"></w-image>
								<div class="goods-table-name">{{scope.row.productname}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="bbcname"
						label="店铺级大类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						v-if="bigcategoryview === 1"
						prop="sbcname"
						:key="0"
						label="店铺级小类"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						:key="1"
						prop="productcode"
						label="商品/规格"
						align="center"
						min-width="240">
						<template slot-scope="scope">
							<div class="goods-table-spec goods-table-spec2">
								<div class="spec-blue" :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)"><span>{{scope.row.producttype ? '组合' : '商品'}}</span>{{scope.row.productcode}}</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)"><span>规格</span>{{item.code}}<img src="~/images/icon/goods-spec.png" class="" v-if="item.url" @click="lookSpecImg(item.url)"></div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						key="unit"
						v-if="!matchbillcenterflag"
						label="单位"
						align="center"
						min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.useunitflag === 1" class="goods-table-spec goods-table-spec2">
								<div style="text-align: center;">{{scope.row.unit.baseUnitName}}</div>
								<div style="text-align: center;">{{scope.row.unit.assistUintName}}({{scope.row.unit.ratio + scope.row.unit.baseUnitName}})</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="code"
						:key="2"
						label="规格名称"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div></div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.spec}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						:key="3"
						prop="stackflag"
						label="销售价"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">{{formateIntervalPrice(scope.row.intervalPrice)}}</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.price === '-1.00' ? '' : item.price}}</div>
							</div>
						</template>
					</el-table-column>

					<!-- <el-table-column
						prop="code"
						v-if="freightType !== 1"
						:key="21"
						label="全部计费方式"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div></div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.usesystemfreightflag ? '按重量' : '按件数'}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						:key="4"
						v-if="(!matchbillcenterflag) || (actualtimeinventoryflag !== 1 && matchbillcenterflag)"
						prop="auditstate"
						label="库存"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">{{scope.row.sumInventory}}</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.inventory}}</div>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column
						prop="disabledflag"
						label="启用状态"
						align="center"
						min-width="110">
							<template slot-scope='scope'>
								<div class="goods-table-qita">
									<div v-if='scope.row.disabledflag === false' :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">启用</div>
									<div v-if='scope.row.disabledflag === true' :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">禁用</div>
									<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"></div>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="hiddenflag"
						label="私密状态"
						align="center"
						min-width="110">
						<template slot-scope='scope'>
							<div class="goods-table-qita">
								<div v-if='scope.row.hiddenflag === false' :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">公开</div>
								<div v-if='scope.row.hiddenflag === true' :class="scope.row.bold ? 'spec-bold': scope.row.bold2 ? 'spec-bold': ''" @mouseover="goodsEnter(scope.$index)" @mouseout="goodsOut(scope.$index)">私密</div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag"></div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column
						prop="freighttemplatename"
						label="可售状态"
						align="center"
						min-width="180">
						<template slot-scope="scope">
							<div class="goods-table-spec">
								<div></div>
								<div v-for="(item, index) in scope.row.spec" :key="index" v-show="scope.row.showFlag" :class="item.bold ? 'spec-bold' : item.bold2 ? 'spec-bold':''" @mouseover="specEnter(scope.$index, index)" @mouseout="specOut(scope.$index, index)">{{item.disabledflag ? '停售' : '可售'}}</div>
							</div>
						</template>
					</el-table-column> -->
					<!-- <el-table-column label="操作" width="160" align="center">
						<template slot-scope="scope">
							<el-button v-if='AuthorityList["02_0001_0004_00"]' type='text' size="small" icon="el-icon-search" @click="getDetail(scope.row)">查看</el-button>
							<el-button @click="deleteClick(scope.row)" v-if='AuthorityList["02_0001_0003_00"] && !matchbillcenterflag' type='text' size="small" icon="el-icon-delete">删除</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</div>
			<div style="height:40px">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="params.page"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="params.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
			</div>
		</div>
			<el-dialog title="添加商品" top='60px' :before-close="cancelClick" class="dialog-title" :visible.sync="bindModal" width='1000px' :close-on-click-modal="false">
				<bindModal ref='bindModal' :isShow.sync='isShow' :sessionStoreId='params.shopid' :dialogVisible.sync='bindModal' :isCheckFlag='isCheck' @cancel='cancel'></bindModal>
			</el-dialog>
			<el-dialog :title="'启用状态 (已勾选' + ids.length + '个商品)'" :before-close="startClose" class="dialog-title" :visible.sync="startModal" width='400px' :close-on-click-modal="false">
				<div>
					<el-radio v-model="startRadio" :label="0" class="radio-box">启用</el-radio>
					<el-radio v-model="startRadio" :label="1" class="radio-box">禁用</el-radio>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="startClose">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="startSave">确认</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog :title="'私密状态 (已勾选' + ids.length + '个商品)'" :before-close="privateClose" class="dialog-title" :visible.sync="privateModal" width='400px' :close-on-click-modal="false">
				<div>
					<el-radio v-model="privateRadio" :label="0" class="radio-box">公开</el-radio>
					<el-radio v-model="privateRadio" :label="1" class="radio-box">私密</el-radio>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="privateClose">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="privateSave">确认</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog title="查看图片" class="dialog-title" :visible.sync="showImgModal" width='400px' :close-on-click-modal="false">
				<div style="text-align:center;"><w-image :src="specImg" style="width: 200px; height:200px;display:inline-block;"></w-image></div>
			</el-dialog>
			<el-dialog title="批量设置可售商品库存" top='60px' :before-close="cancelSetMuit" class="dialog-title" :visible.sync="showSetMuit" width='1350px' :close-on-click-modal="false">
				<setMuti :show.sync='showSetMuit' :sessionStoreId='params.shopid'></setMuti>
			</el-dialog>
			<el-dialog top='60px' class="detail-dialog-title" :visible.sync="detailModal" width='1000px' :before-close="isClose" :close-on-click-modal="false">
				<ViewModal ref="viewModal" :visible.sync='detailModal' @isClose='isClose' :goodsId='goodsId' :productId='productId' v-if="detailModal" :showBtn='showBtn'></ViewModal>
			</el-dialog>
			<el-dialog title="批量设置副标题" top='60px' class="dialog-title" :visible.sync="showSetTitle" width='1000px' :close-on-click-modal="false">
				<div class="setTitle-box">
					<div class="title-select-box">
						<div>
							<div class="">选中设副标题：</div>
							<el-input size='mini' class="title-input" :maxlength='100'  @change="subtitleChange" v-model="subtitle" placeholder="限100字符内，支持中英文数字特殊符号"></el-input>
							<el-button style="margin-left:10px" size='mini' @click="mutiSave" type='primary' plain>确定</el-button>
						</div>
						<div>
							<div class="">选中颜色：</div>
							<el-color-picker size='mini' @change="subtitlecolourChange" :predefine="predefineColors" v-model="subtitlecolour"></el-color-picker>
						</div>
					</div>
					<div class="title-table-box">
						<el-table
							:stripe='true'
							class="grid-content"
							:data="titleTableData"
							size='mini'
							:height="tableHeight"
							border
							:cell-class-name="addCellClass"
							@selection-change="handleSelectionTitleChange">
							<el-table-column
							type="selection"
							align="center"
							width="55">
							</el-table-column>
							<el-table-column
								label-class-name = "column-index"
								label="序号"
								type="index"
								width="70"
								align="center">
							</el-table-column>
							<el-table-column
								prop="productname"
								:show-overflow-tooltip='true'
								label="商品名称"
								align="center"
								width="180">
							</el-table-column>
							<el-table-column
								label="副标题"
								align="center"
								min-width="180">
								<template slot-scope='scope'>
									<el-input size='mini' class="title-input" :maxlength='100' v-model="scope.row.subtitle"  @change="subtitleChange1(scope.row)" placeholder="限100字符内，支持中英文数字特殊符号"></el-input>
									<el-color-picker size='mini' :predefine="predefineColors" v-model="scope.row.subtitlecolour" @change="subtitlecolourChange1(scope.row)"></el-color-picker>
								</template>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								width="100">
								<template slot-scope='scope'>
									<div class="btn-box" @click="delClick(scope.$index)">
										<img src="~/images/icon/del-icon.png" alt="">移除
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="titleCancel">取消</el-button>
						<el-button class="btn" plain type="primary" size='small' @click="titleSave">保 存</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog :title="'批量设置 (已选择' + ids.length + '个商品)'" :before-close="cancelBatchSetting" class="dialog-title" :visible.sync="showBatchSetting" width='1000px' :close-on-click-modal="false">
				<el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="form-box" v-if="showBatchSetting">
					<div class="batchSetBox">
						<div class="input-box">
							<span>字段名：</span>
							<el-select v-model="ruleForm.word" class="filter-input" size='small' @change="wordChange">
								<el-option value="1" label="快速设置店铺级分类"></el-option>
								<el-option value="2" label="快速设置商品顺序号"></el-option>
								<el-option v-if="freightType !== 1 && !stopFlag" value="4" label="快速设置运费"></el-option>
								<!-- <el-option value="3" label="更新商品销售价格"></el-option> -->
							</el-select>
						</div>
						<div v-show="ruleForm.word === '1'">
							<div class="input-box">
								<span>店铺级大类：</span>
								<el-select v-model="ruleForm.bigTypeCategory" class="filter-input" placeholder="请选择店铺级大类" size='small' @change="bigCategoryChange('ruleForm')">
									<template v-for="(item) in bigCategoryList">
										<el-option
											:value="item.bc_id"
											:label="item.bc_name"
											:key="item.bc_id"
											:disabled="item.disabledflag"/>
								</template>
								</el-select>
							</div>
							<div class="input-box" v-if="bigcategoryview === 1">
								<span>店铺级小类：</span>
								<el-select v-model="ruleForm.smallTypeCategory" class="filter-input" placeholder="请选择店铺级小类" size='small' @change="smallCategoryChange('ruleForm')">
									<template v-for="(item) in smallCategoryList">
										<el-option
											:key="item.id"
											:label="item.name"
											:value="item.id"
											:disabled="item.disabledflag">
										</el-option>
									</template>
								</el-select>
							</div>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveBatchSetting">确认</el-button>
							</div>
						</div>
						<div class="table-box-sort" v-show="ruleForm.word === '2'">
							<el-table
								:stripe='true'
								size='mini'
								ref='multipleTable'
								class="grid-content"
								:data="seqnumTable"
								max-height='400'
								border>
									<el-table-column
										label-class-name = "column-index"
										label="序号"
										type="index"
										width="70"
										align="center">
									</el-table-column>
									<el-table-column
										prop="productname"
										label="商品名称"
										align="center"
										min-width="180">
									</el-table-column>
									<el-table-column
										prop="productcode"
										label="商品编号"
										align="center"
										min-width="160">
									</el-table-column>
									<el-table-column
										prop="seqnum"
										label="商品顺序号"
										sortable
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-input
												class="num-input"
												v-model="scope.row.seqnum"
												size="small"
												@input="numInput(scope.row)"
												@blur="numBlur(scope.row)"
											></el-input>
										</template>
									</el-table-column>
									<el-table-column
									prop="disabledflag"
									label="启用状态"
									align="center"
									min-width="100">
									<template slot-scope="scope">{{ scope.row.disabledflag ? '禁用' : '启用' }}</template>
									</el-table-column>
									<el-table-column
										prop="bbcname"
										label="店铺级大类"
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-select v-model="scope.row.bigTypeCategory" class="filter-input" placeholder="请选择店铺级大类" size='small' @change="seqBigCategoryChange(scope.row)">
												<template v-for="(item) in scope.row.bigCategoriesList">
													<el-option
														:value="item.bc_id"
														:label="item.bc_name"
														:key="item.bc_id"
														v-if="!item.disabledflag"/>
												</template>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column
										v-if="bigcategoryview === 1"
										prop="sbcname"
										label="店铺级小类"
										align="center"
										min-width="100">
										<template slot-scope="scope">
											<el-select v-model="scope.row.smallTypeCategory" class="filter-input" placeholder="请选择店铺级小类" size='small'>
												<template v-for="(item) in scope.row.smallCategoriesList">
													<el-option
														:key="item.id"
														:label="item.name"
														:value="item.id"
														v-if="!item.disabledflag">
													</el-option>
												</template>
											</el-select>
										</template>
									</el-table-column>
							</el-table>
							<div class="title-btn-box">
								<el-button class="btn" plain type="primary" size='small' @click="saveSecSetting">确认</el-button>
							</div>
						</div>
						<div v-if="ruleForm.word === '4'">
							<Freight :spceList='spceList' @saveFreight='saveFreight' @cancelFreight='cancelFreight' :orginData='orginData'></Freight>
						</div>
						<!-- <div v-show="ruleForm.word === '3'">
							<div style="color: #F56C6C;margin-left: 50px;">*如果导入模板销售价、重量、最小起重量为空、则不做更新。</div>
							<div style="margin-left: 50px;display: flex;align-items: center;cursor:pointer;">
								<img src="~/images/icon/download.png">
								<el-button class="btn" type="text" size='small' @click="downloadFile">
									下载导入模板
								</el-button>
								<a :href="downloadUrl" ref="download" v-show="false"></a>
							</div>
							<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
							<div style="text-align: center;">
								<el-button class="btn" plain type="primary" size='small' @click="importPriceExcel">
									导入
								</el-button>
							</div>
						</div> -->
					</div>
				</el-form>
			</el-dialog>
			<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px;text-align: left;overflow:auto" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Freight from '@/components/freight/freight.vue'
import bindModal from '@/components/storeSetting/saleableGoods/BindModal.vue'
import setMuti from '@/components/storeSetting/saleableGoods/setMuti.vue'
import ViewModal from '@/components/storeSetting/saleableGoods/ViewModal.vue'
import Search from '@/components/storeSetting/saleableGoods/Search.vue'
export default {
	name: 'storeBasicInfo',
	components: {
		Search,
		bindModal,
		ViewModal,
		setMuti,
		Freight
	},
	data () {
		return {
			orginData: [],
			freightType: 0,
			AuthorityList: {
				'02_0001_0001_00': false,
				'02_0001_0002_00': false,
				'02_0001_0003_00': false,
				'02_0001_0004_00': false,
				'02_0001_0005_00': false,
				'02_0001_0006_00': false,
				'02_0001_0007_00': false,
				'02_0001_0008_00': false,
				'02_0001_0009_00': false,
				'02_0001_0010_00': false
			},
			actualtimeinventoryflag: null,
			subtitle: '',
			subtitlecolour: '',
			predefineColors: [
				'#333333', '#4a4a4a', '#ffffff', '#d0021b', '#f5a623', '#f8e71c', '#8b572a', '#7ed321', '#417505', '#bd10e0', '#9013fe', '#4a90e2', '#50e3c2', '#b8e986', '#000000'
			],
			showSetMuit: false,
			showSetTitle: false,
			shopName: '',
			productId: '',
			goodsId: '',
			showBtn: false,
			editDisable: false,
			addDisable: false,
			bindModal: false,
			isShow: false,
			detailModal: false,
			isCheck: false,
			startModal: false,
			privateModal: false,
			showImgModal: false,
			showBatchSetting: false,
			startRadio: 0,
			privateRadio: 0,
			specImg: '',
			params: {
				shopIds: [],
				productName: '',
				productCode: '',
				bigTypeCategory: '0',
				smallTypeCategory: '0',
				matchname: '',
				page: 1,
				size: 20,
				disabledflag: -1,
				usesystemfreightflag: null,
				hiddenflag: -1
			},
			tableData: [],
			titleTableData: [],
			seqnumTable: [],
			tableHeight: '100%',
			total: 0,
			pid: [],
			titleIds: [],
			excelParams: {},
			bigcategoryview: 0,
			bigCategoryList: [],
			smallCategoryList: [],
			ruleForm: {
				word: '1',
				bigTypeCategory: '',
				smallTypeCategory: ''
			},
			isTrue: true,
			tempflag: 0,
			matchbillcenterflag: false,
			showFlag: true,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'productid',
				selectHandler: this.tableSelectUtilsHandler
			}),
			spceList: [],
			tipModal: false,
			tipData: [],
			downloadUrl: '',
			stopFlag: false
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		this.params.shopIds = Array(sessionStorage.getItem('storeid'))
		let params = sessionStorage.getItem('goodsParams')
		if (params) {
			this.params = JSON.parse(params)
		}
		this.getFreight()
		this.tableReload()
		this.getAuditShop()
		this.getAuthority('02_0001_0000_00')
		this.checkSmallCategory()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		cancelFreight () {
			this.showBatchSetting = false
		},
		getFreight () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/get`
			}).then(res => {
				if (res.result) {
					let list = res.data.freightDetailDTOList || []
					this.stopFlag = res.data.stopFlag
					this.freightType = res.data.freightType
					if (list.length > 0) {
						list.forEach(item => {
							let nameArr = item.areaname.split(',')
							item.provinces = item.provinces.split(',')
							item.showname = item.areaname
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
						})
					}
					this.orginData = list
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveFreight () {
			this.tableSelectUtils.clear()
			this.showBatchSetting = false
			this.tableReload()
		},
		tableSelectUtilsHandler (row) {
			return {
				productid: row.productid,
				spec: row.spec
			}
		},
		importExcel () {
			this.$router.push('importExcel')
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.actualtimeinventoryflag = res.actualtimeinventoryflag
				this.bigcategoryview = res.bigcategoryview
				this.matchbillcenterflag = res.matchbillcenterflag === 1
			})
			// })
		},
		// 批量设置切换
		wordChange (e) {
			if (e === '2') {
				this.ruleForm.word = '1'
				this.$confirm('确认关闭当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.ruleForm.word = '2'
				}).catch(() => {})
			} else if (e === '1') {
				this.ruleForm.word = '2'
				this.$confirm('确认关闭当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.ruleForm.word = '1'
				}).catch(() => {})
			}
		},
		getSeqnumTable () {
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let params = {
				ids: list.join(','),
				shopid: this.params.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/getProductInfo4Seqnum`,
				data: params
			}).then(res => {
				if (res.result === true) {
					// this.tableSelectUtils.clear()
					this.seqnumTable = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		numBlur (data) {
			if (data.seqnum === '' || data.seqnum === null) {
				data.seqnum = '0'
			}
		},
		numInput (data) {
			let seqnum = data.seqnum.replace(/[^\d-]/g, '')
			if (seqnum !== '' && seqnum !== null) {
				data.seqnum = seqnum
			} else {
				data.seqnum = ''
			}
		},
		// 规格悬停加粗
		specEnter (index, index1) {
			this.tableData[index].spec[index1].bold2 = true
		},
		specOut (index, index1) {
			this.tableData[index].spec[index1].bold2 = false
		},
		// 商品点击加粗
		goodsEnter (index, index1) {
			this.tableData[index].bold2 = true
		},
		goodsOut (index, index1) {
			this.tableData[index].bold2 = false
		},
		// 处理老数据
		getOldData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/dealOldProductAttrType`
			}).then(res => {})
		},
		tableRowClassName ({ row, rowIndex }) {
			if (row.checked) {
				return 'check-row'
			}
			return ''
		},
		subtitleChange () {
			if (this.subtitle.match(/^[ ]*$/)) {
				this.subtitle = ''
			}
			this.subtitle = this.subtitle.replace(/['\\]/g, '')
		},
		subtitleChange1 (row) {
			if (row.subtitle.match(/^[ ]*$/)) {
				row.subtitle = ''
			}
			row.subtitle = this.subtitle.replace(/['\\]/g, '')
		},
		subtitlecolourChange1 (row) {
			if (row.subtitlecolour === null) {
				row.subtitlecolour = '#000000'
			}
		},
		delClick (data) {
			this.titleTableData.splice(data, 1)
			this.$message.success('移除成功')
		},
		mutiSave () {
			if (this.subtitle === '') {
				this.$message.error('请输入副标题')
				return false
			} else {
				let ids = this.titleIds
				let list = this.titleTableData
				if (ids.length > 0) {
					for (let i = 0; i < ids.length; i++) {
						for (let j = 0; j < list.length; j++) {
							if (list[j].id === ids[i]) {
								list[j].subtitle = this.subtitle
								break
							}
						}
					}
				} else {
					for (let i = 0; i < list.length; i++) {
						list[i].subtitle = this.subtitle
					}
				}
				this.titleTableData = list
			}
		},
		subtitlecolourChange () {
			if (this.subtitlecolour === null) {
				this.subtitlecolour = '#000000'
			}
			let ids = this.titleIds
			let list = this.titleTableData
			if (ids.length > 0) {
				for (let i = 0; i < ids.length; i++) {
					for (let j = 0; j < list.length; j++) {
						if (list[j].id === ids[i]) {
							list[j].subtitlecolour = this.subtitlecolour
							break
						}
					}
				}
			} else {
				for (let i = 0; i < list.length; i++) {
					list[i].subtitlecolour = this.subtitlecolour
				}
			}
			this.titleTableData = list
		},
		addCellClass (row) {
			if (row.columnIndex === 3) {
				return 'cellClass'
			}
		},
		clearTitle () {
			let list1 = []
			this.ids.forEach(item => {
				list1.push(item.productid)
			})
			let list = list1
			let params = []
			for (let i = 0; i < list.length; i++) {
				params.push({
					id: list[i]
				})
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitles/clean`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.$message.success('操作成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearTitleClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个商品！')
				return false
			}
			this.$confirm('是否确认批量清空副标题？一经操作无法复原', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.clearTitle()
			})
		},
		titleCancel () {
			this.showSetTitle = false
		},
		titleSave () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitles/save`,
				data: this.titleTableData
			}).then(res => {
				console.log(res)
				if (res.result === true) {
					this.$message.success('保存成功')
					this.showSetTitle = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
					this.errorEvent(res.data)
				}
			})
		},
		errorEvent (data) {
			let ids = []
			for (let i = 0; i < data.length; i++) {
				ids.push(data[i].id)
			}
			let id = ids.join(',')
			let params = {
				ids: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitle/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let list = res.data
					this.titleTableData = list
					this.subtitlecolour = ''
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSelectionTitleChange (data) {
			let ids = []
			for (let i = 0; i < data.length; i++) {
				ids.push(data[i].id)
			}
			this.titleIds = ids
		},
		setTitle () {
			if (this.ids.length === 0) {
				this.$message.error('请至少勾选一个商品！')
				return false
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let id = list.join(',')
			let params = {
				ids: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/subtitle/list`,
				data: params
			}).then(res => {
				console.log(res)
				if (res.result === true) {
					this.tableSelectUtils.clear()
					this.titleTableData = res.data
					this.showSetTitle = true
					this.subtitle = ''
					this.subtitlecolour = ''
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		exportExcel () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/product/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			this.params.ids = list.join(',')
			req.send(JSON.stringify(this.params))
		},
		download (blobUrl) {
			var date = new Date()
			var year = date.getFullYear()
			var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + ''
			var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ''
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ''
			var min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + ''
			let curDate = year + month + day + hour + min + seconds
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = '可售商品档案(' + curDate + ').xls'
			a.href = blobUrl
			a.click()
		},
		cancelSetMuit () {
			this.showSetMuit = false
			this.tableReload()
		},
		setMuit () {
			this.showSetMuit = true
		},
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		isClose () {
			if (this.$refs.viewModal.returnChange()) {
				this.detailModal = true
				this.$confirm('当前页面未保存，是否确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.detailModal = false
				}).catch(() => {})
			} else {
				this.tableReload()
				this.detailModal = false
			}
		},
		getAuditShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getAuditShopCount`
			}).then(res => {
				if (res.result === true) {
					if (res.data.auditShopCount === 0) {
						this.isCheck = false
					} else {
						this.isCheck = true
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		startStatus () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选商品！')
				return false
			}
			this.startRadio = 0
			this.startModal = true
		},
		startClose () {
			this.startModal = false
			this.startRadio = 0
		},
		startSave () {
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let params = {
				productIds: list,
				disabledflag: this.startRadio
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/disabledflag`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (this.startRadio === 0) {
						this.$message.success('勾选商品启用状态更换成功！')
					} else {
						this.$message.success('勾选商品禁用状态更换成功！')
					}
					this.startModal = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		privateSave () {
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let params = {
				productIds: list,
				hiddenflag: this.privateRadio
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/hiddenflag`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (this.privateRadio === 0) {
						this.$message.success('勾选商品公开状态更换成功！')
					} else {
						this.$message.success('勾选商品私密状态更换成功！')
					}
					this.privateModal = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		privateStatus () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选商品！')
				return false
			}
			this.privateRadio = 0
			this.privateModal = true
		},
		privateClose () {
			this.privateModal = false
			this.privateRadio = 0
		},
		statusChange (data) {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let id = list.join(',')
			let params = {
				ids: id,
				stackFlag: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/relation/updateGoodsStackFlag`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableSelectUtils.clear()
					if (data === 0) {
						this.$message.success('上架成功')
					} else {
						this.$message.success('下架成功')
					}
					this.tableReload()
				} else {
					if (res.code === 999) {
						let name = []
						res.data.forEach(e => {
							name.push(e.info)
						})
						this.$alert('［' + name.join(',') + '］没有店铺类别,修改上下架状态失败', '提示', {
							confirmButtonText: '确定',
							type: 'warning',
							callback: action => {
							}
						})
					} else {
						this.$message.error(res.msg)
					}
				}
			})
		},
		cancel (data) {
			this.bindModal = data
			this.isShow = data
			this.tableReload()
		},
		addClick () {
			window.sessionStorage.removeItem('productid')
			this.$router.push({
				path: 'newProduct',
				query: { isAdd: true, from: 'storeSetting/relatedGoods' }
			})
		},
		cancelClick () {
			this.bindModal = false
			this.isShow = false
		},
		handleSizeChange (val) {
			this.params.size = val
			window.sessionStorage.removeItem('goodsParams')
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.params.page = val
			window.sessionStorage.removeItem('goodsParams')
			this.tableReload()
		},
		getTableDataHandle (data) {
			this.tableSelectUtils.clear()
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			this.params = data
			let excelParams = {
				id: 0,
				shopid: this.params.shopid,
				hiddenFlag: -1,
				stackFlag: this.params.stackFlag,
				goodsName: this.params.goodsName,
				freightTemplateid: this.params.freightTemplateid,
				subtitle: this.params.subtitle,
				bcId: this.params.bcId,
				scId: this.params.scId,
				saleState: this.params.saleState,
				auditState: this.params.auditState,
				matchname: this.params.matchname,
				usesystemfreightflag: this.params.usesystemfreightflag,
				comFlag: 0,
				sourceflag: -1,
				unitFlag: -1
			}
			this.excelParams = excelParams
		},
		handleSelectionChange (value) {
			this.tableSelectUtils.selectToggle(this.tableData, value)
			this.tableData.filter(e => {
				if (value.indexOf(e) > -1) {
					e.checked = true
				} else {
					e.checked = false
				}
			})
		},
		// 查看规格图片
		lookSpecImg (url) {
			this.showImgModal = true
			this.specImg = url
		},
		// 折叠规格
		showFold (index) {
			this.tableData[index].showFlag = !this.tableData[index].showFlag
		},
		tableReload () {
			let excelParams = {
				subtitle: this.params.subtitle,
				freightTemplateid: this.params.freightTemplateid,
				id: 0,
				shopid: this.params.shopid,
				hiddenFlag: -1,
				stackFlag: 2,
				goodsName: this.params.goodsName,
				bcId: this.params.bcId,
				scId: this.params.scId,
				saleState: 2,
				auditState: 4,
				comFlag: 0,
				sourceflag: -1,
				unitFlag: -1
			}
			this.excelParams = excelParams
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/productlist`,
				data: this.params
			}).then(res => {
				if (res.recordCount !== 0) {
					res.recordList.forEach(e => {
						if (e.commpressflag) {
							if (e.url) {
								e.url = this.$fxUtils.changeImgSrc(e.url, 'big')
							}
						}
						if (this.showFlag) {
							e.showFlag = false
						} else {
							e.showFlag = true
						}
						e.bold = false
						e.bold2 = false
						e.spec.forEach(item => {
							item.bold = false
							item.bold2 = false
						})
					})
				}
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
				this.total = res.recordCount
				this.tempflag = res.tempflag

				let params = sessionStorage.getItem('goodsParams')
				if (params) {
					let scrollTopValue = JSON.parse(params).scrollTopValue
					let tableContainer = document.querySelector('.el-table__body-wrapper')
					this.$nextTick(() => {
						tableContainer.scrollTop = scrollTopValue
						this.$refs.table.doLayout()
					})
				}
			})
		},
		deleteList () {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			this.$confirm('是否删除已勾选【' + this.ids.length + '】个商品和提成规则？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let list = []
				this.ids.forEach(item => {
					list.push(item.productid)
				})
				let params = {
					productIds: list
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/product/del`,
					data: params
				}).then(res => {
					if (res.result) {
						this.tableSelectUtils.clear()
						this.$message.success('商品删除成功！')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		deleteClick (data) {
			this.$confirm('是否删除【' + data.productname + '】和提成规则？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					productIds: [data.productid]
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/product/del`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('商品删除成功！')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		getDetail (data) {
			let tableContainer = document.querySelector('.el-table__body-wrapper')
			let scrollTopValue = tableContainer.scrollTop
			let params = this.params
			params.scrollTopValue = scrollTopValue
			window.sessionStorage.setItem('goodsParams', JSON.stringify(params))
			window.sessionStorage.setItem('productid', data.productid)
			let producttype = data.producttype
			if (producttype === 1) {
				producttype = true
			} else {
				producttype = false
			}
			this.$router.push({
				path: '/main/newProduct',
				query: { producttype, isAdd: false, from: 'storeSetting/relatedGoods' }
			})
		},
		batchSetting () {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个商品！')
				return false
			}
			this.initSpecId()
			this.ruleForm.word = '1'
			this.showBatchSetting = true
			this.getBigCategory()
			this.getSeqnumTable()
		},
		initSpecId () {
			let list = this.ids
			let spceList = []
			list.forEach(item => {
				item.spec.forEach(specItem => {
					spceList.push(specItem.specid)
				})
			})
			this.spceList = spceList
		},
		cancelBatchSetting () {
			this.$confirm('确认关闭当前页面？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.showBatchSetting = false
				this.ruleForm.word = '1'
			}).catch(() => {})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bigCategoryList = res.data.filter(item => !item.disabledflag)
					this.ruleForm.bigTypeCategory = this.bigCategoryList[0].bc_id
				}
				if (this.bigcategoryview === 1) {
					this.getSmalCategory()
				}
			})
		},
		getSmalCategory () {
			return new Promise((resolve, reject) => {
				let params = {
					pid: this.ruleForm.bigTypeCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						this.ruleForm.smallTypeCategory = res.data[0].id
						this.smallCategoryList = res.data.filter(item => !item.disabledflag)
						resolve(res)
					}
				})
			})
		},
		seqBigCategoryChange (row) {
			if (this.bigcategoryview === 1) {
				let params = {
					pid: row.bigTypeCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						row.smallTypeCategory = res.data[0].id
						row.smallCategoriesList = res.data.filter(item => !item.disabledflag)
					}
				})
			}
		},
		bigCategoryChange (data) {
			this.ruleForm.smallTypeCategory = ''
			this.categoryChange(data)
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		smallCategoryChange (data) {
			this.categoryChange(data)
		},
		categoryChange (formName) {
			if (this.ruleForm.bigTypeCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallTypeCategory === '')) {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('category', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		saveSecSetting () {
			let params = {
				productSeqnumDTOS: this.seqnumTable
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/seqnum`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.showBatchSetting = false
					this.ruleForm.bigTypeCategory = ''
					this.ruleForm.smallTypeCategory = ''
					this.ruleForm.word = '1'
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveBatchSetting () {
			let list = []
			this.ids.forEach(item => {
				list.push(item.productid)
			})
			let params = {
				bigTypeCategory: this.ruleForm.bigTypeCategory,
				smallTypeCategory: this.ruleForm.smallTypeCategory ? this.ruleForm.smallTypeCategory : '0',
				productIds: list
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/update/category`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('批量修改店铺级分类成功！')
					this.showBatchSetting = false
					this.ruleForm.bigTypeCategory = ''
					this.ruleForm.smallTypeCategory = ''
					this.ruleForm.word = '1'
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		renderHeader (h, { column, $index }) {
			return h(
				'div', {
					class: 'header-div'
				},
				[
					h('div', {
						class: 'showFlag',
						on: {
							'click': ($index) => {
								this.handleAddItem($index)
							}
						}
					}, this.showFlag ? '+' : '-'),
					h('span', '商品信息')
				]
			)
		},
		handleAddItem (event) {
			if (this.tableData) {
				this.tableData.forEach((item, index) => {
					if (this.showFlag) {
						this.tableData[index].showFlag = true
					} else {
						this.tableData[index].showFlag = false
					}
				})
			}
			this.showFlag = !this.showFlag
		},
		formateIntervalPrice (val) {
			if (val) {
				let arr = val.split('～')
				if (arr[0] === arr[1]) {
					return arr[0]
				} else {
					return val
				}
			}
		},
		importPriceExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			this.uploadGoodsHandle()
			this.$refs.file.value = ''
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/product/price/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.tableData = res.data
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.tipData = res.data
						this.tipModal = true
					}
				})
			})
		},
		downloadFile () {
			const that = this
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/productprice/importExcel/template/url`
			}).then(res => {
				this.downloadUrl = res.data + '?timestamp=' + new Date().getTime()
				setTimeout(function () {
					that.$refs.download.dispatchEvent(new MouseEvent('click'))
				}, 500)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.fx-big-btn1{
	width:120px;
}
.clear-box{
	width:100%;
	height:150px;
}
.spec-bold {
	font-weight: bold
}
.table-box-sort {
	// height: auto;
	// max-height: 400px
}
.store-basic-info {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		padding-left :10px;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.store-basic-header {
		border-bottom: 1px solid #dce2fd;
		height:78px;
		line-height: 78px;
		font-size: 20px;
		p {
			height: 100%
			box-sizing:border-box
			border-bottom: 3px solid var(--fx-primary-color);
			float left
		}
	}
	.features-btn-box {
		height:40px;
		text-align left
		padding :10px;
		border-top: 1px solid #dce2fd;
		display flex
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 20px;
			display: flex;
			height: 32px;
			justify-content: center;
			align-items: center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
	.table-box {
		// flex:1
		// padding-bottom :10px;
		// display: flex;
		// flex-direction: column;
		height: calc(100% - 60px);
		padding-bottom: 10px;
		overflow-y: auto;
		.goods-table.grid-content {
			font-size: 14px;
			color: #333;
		}
	}
	.table-div{
		// display :flex;
		// flex-direction :column;
		flex: 1;

		.goods-table-info {
			display: flex;
			img {
				flex-shrink: 0
			}
			.goods-table-fold {
				display: flex;
				align-items: center;
				margin-right: 10px;
				.showFlag {
					display: inline-block;
					width: 15px;
					height: 15px;
					line-height: 15px;
					text-align: center;
					color: #fff;
					background-color: var(--fx-primary-color);
					cursor: pointer;
					font-weight: bold;
					font-size: 14px;
				}
			}
			.goods-table-name {
				color: #333;
				display: flex;
				align-items: center;
				margin-left: 10px;
			}
		}
		.goods-table-spec {
			&>div {
				height: 28px;
				line-height: 28px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&.spec-blue {
					color: var(--fx-primary-color);
					span {
						border: 1px solid var(--fx-primary-color);
					}
				}
				img {
					display: inline-block;
					width: 12px;
					height: 12px;
					cursor: pointer;
					margin-left: 5px;
				}
				span {
					display: inline-block;
					border: 1px solid #ccc;
					border-radius: 2px;
					width: 30px;
					height: 16px;
					text-align: center;
					line-height: 18px;
					margin-right: 5px;
					font-size: 12px;
				}
			}
			&.goods-table-spec2>div{
				text-align: left;
				padding-left: 15px;
			}
		}
		.goods-table-qita {
			&>div {
				height: 28px;
				line-height: 28px;
			}
		}
	}

	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}

}

.title-input{
	width :400px;
	margin-right:10px
}
.setTitle-box{
	width:100%;
	height:440px;
	.title-select-box{
		width:100%;
		height:50px;
		border-top:1px solid #DEE3FE;
		display:flex;
		flex-direction: row;
		align-items: center;
		justify-content:space-between
		div{
			display:flex;
			flex-direction: row;
			align-items: center;
		}
	}
	.title-table-box{
		height:350px
	}
}
	.title-btn-box{
		height:40px;
		padding:10px;
		box-sizing:border-box;
		text-align:center
		.btn{
			width:130px;
		}
	}
	.radio-box {
		display: block;
		margin: 0 0 10px 50px;
	}
	.batchSetBox {
		span {
			display: inline-block;
			width: 90px;
			text-align: right;
		}
		.input-box {
			margin: 10px 20px;
		}
	}
</style>
<style lang="stylus">
.btn-box{
	display:flex;
	flex-direction:row;
	align-items :center;
	justify-content: center;
	cursor: pointer;
	color:var(--fx-primary-color);
	img{
		width:20px;
		height:20px;
		margin-right:4px;
	}
}
.el-table-column--selection {
	.cell{
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
}
	.el-table .check-row {
		background: #F3F7FF;
	}
.cellClass {
	.cell{
		display:flex;
		flex-direction:row;
		align-items:center;
		justify-content:center
	}
}
.store-basic-info {
	.el-dialog__body {
		padding-top: 10px
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px
			border: none
		}
	}
}
.header-div {
	line-height: 15px;
}
.showFlag {
	display: inline-block;
	float: left;
	width: 15px;
	height: 15px;
	line-height: 15px;
	text-align: center;
	color: #fff;
	background-color: var(--fx-primary-color);
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
}
</style>
